import "./Hero.css";

function Hero() {
  return (
    <div
      className="hero"
      style={{
        backgroundImage:
          "linear-gradient(to bottom, rgba(0,0,0,0) 40%, rgba(0,0,0,.75)), url('/images/hero-studio.png')"
      }}
    >
      <div className="hero-lights"></div>
    </div>
  );
}

export default Hero;

